import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconWrite3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWrite3"><Path d="M4 21.5H20" stroke="currentColor"/><Path d="M7.5 21.25L4.5 13.5L12.0001 3L19.5 13.5L16.5 21.25" stroke="currentColor"/><Circle cx="12" cy="14" r="2.25" stroke="currentColor"/><Path d="M12 12V3.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconWrite3;
